import {
  Bold
} from './bold'

import {
  Code
} from './code'

import {
  Italic
} from './italic'

import {
  Underline
} from './underline'

export {
  Bold,
  Code,
  Italic,
  Underline
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/inline-style/index.js
 **/